import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActiontrackerConstantsService } from '../actiontracker/services/actiontracker-constants.service';
import { MasterscreenService } from '../masterscreen/services/masterscreen.service';
import { RaisePassRequestComponent } from '../person-on-board/components/raise-pass-request/raise-pass-request.component';
import { PersononboardRoutingModule } from '../person-on-board/persononboard-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CheckinOutComponent } from './components/checkin-out/checkin-out.component';
import { PassRequestsDashboardComponent } from './components/pass-requests-dashboard/pass-requests-dashboard.component';
import { PobListDashboardComponent } from './components/pob-list-dashboard/pob-list-dashboard.component';
import { ViewPassRequestComponent } from './components/view-pass-request/view-pass-request.component';
import { PersononboardService } from './services/persononboard.service';

@NgModule({
  imports: [
    CommonModule,
    PersononboardRoutingModule,
    SharedModule,
    FormsModule
  ],
  declarations: [
    RaisePassRequestComponent,
    PassRequestsDashboardComponent,
    PobListDashboardComponent,
    ViewPassRequestComponent,
    CheckinOutComponent
  ],
  providers: [
    PersononboardService,
    MasterscreenService,
    ActiontrackerConstantsService
  ],
})
export class PersonOnBoardModule { }
